// @ts-nocheck
import React, { useEffect } from 'react';
import { LoginScanStyle } from './styles';

export const LoginFsScan: React.FC<{ id?: string }> = ({ id = 'login_fs_container' }) => {
  useEffect(() => {
    const url = new URL(window.location.href);
    const tUrl = url.searchParams.get('targetUrl')
    const targetUrl = (tUrl && decodeURIComponent(tUrl).indexOf(window.location.origin) >= 0) ? decodeURIComponent(tUrl) : window.location.origin;
    const env = window.localStorage.getItem('env');
    const client_id = env === 'prod' ? 'cli_a62218cb676e500c' : 'cli_a62a02c9c5b6d013'
    const goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${client_id}&redirect_uri=${targetUrl}&response_type=code&state=FEISHU`
    var QRLoginObj = QRLogin({
      id: id,
      goto: goto,
      width: "500",
      height: "500",
      style: "width:500px;height:600px"//可选的，二维码html标签的style属性
    });

    var handleMessage = function (event) {
      // 使用 matchOrigin 和 matchData 方法来判断 message 和来自的页面 url 是否合法
      if (QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) {
        var loginTmpCode = event.data.tmp_code;
        // 在授权页面地址上拼接上参数 tmp_code，并跳转
        console.log(loginTmpCode, 'loginTmpCode');
        window.location.href = `${goto}&tmp_code=${loginTmpCode}`;
      }
    };
    if (typeof window.addEventListener != 'undefined') {
      window.addEventListener('message', handleMessage, false);
    }
    else if (typeof window.attachEvent != 'undefined') {
      window.attachEvent('onmessage', handleMessage);
    }
  }, []);


  return (
    <LoginScanStyle>
      <div className='title'> <img src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/feishu/feishu.png" alt="" />飞书登录</div>

      <div id={id} />
      <div className='tip'>
        <span>请使用飞书扫描二维码登录</span>
        <br />
        <span>“遥望云飞书扫码”</span>
      </div>
    </LoginScanStyle>
  );
};
